export type BroadcasterNameMember = {
  display_name?: string | null;
  twitch_login?: string | null;
  provider_login?: string | null;
};

function sameLogin(left?: string | null, right?: string | null): boolean {
  const a = (left ?? '').trim().toLowerCase();
  const b = (right ?? '').trim().toLowerCase();
  return Boolean(a) && a === b;
}

export function broadcasterDisplayName(input: {
  login?: string | null;
  twitchDisplayName?: string | null;
  memberName?: string | null;
  members?: BroadcasterNameMember[];
}): string {
  const login = (input.login ?? '').trim();
  const linked = (input.members ?? []).find(
    (member) => sameLogin(member.twitch_login, login) || sameLogin(member.provider_login, login)
  );
  const memberName = (linked?.display_name ?? input.memberName ?? '').trim();
  const twitchName = (input.twitchDisplayName ?? '').trim();
  // A roster name that is only the login is not a separate name. The Twitch
  // display name is the next fallback, then the login.
  if (memberName && !sameLogin(memberName, login)) return memberName;
  if (twitchName && !sameLogin(twitchName, login)) return twitchName;
  if (memberName) return memberName;
  return login;
}
